export default class novaEmbalagemViewModel {
    constructor() {
        this.EmbalagemCaixaColetiva = undefined;
        this.EmbalagemEspecificaFilmeEncolhivel = undefined;
        this.EmbalagemEspecificaPalete = undefined;
        this.EmbalagemEspecificaPapelEmbrulho = undefined;
        this.QuantidadeCaixaColetiva = undefined;
        this.QuantidadeFilmeEncolhivel = undefined;
        this.QuantidadePalete = undefined;
        this.QuantidadePapelEmbrulho = undefined;
    }
}